import useFavoritedProductIds from 'hooks/useFavoritedProductIds';
import useStaticWishlistData from './useStaticWishlistData';

const useFavoritesStaticProductData = () => {
  const { data } = useFavoritedProductIds();
  const productIds = data?.productIds ?? [];

  return useStaticWishlistData({ productIds });
};

export default useFavoritesStaticProductData;
